import TypeService from "./types.service";
export default class CategoryService extends TypeService {
  namespace = "category";
  icon = "GreenCube";
  name = "Category";
  favicon = "GreenCube";
  window = 290;
  Width = 690;
  realm = 1;
  DOMAIN = 3;
  action = "action";
  singular = this.terminology.category.singular;
  plural = this.terminology.category.plural;
  vowel = this.terminology.category.vowel;

  constructor() {
    super("types");
  }
}
